const GOOGLE_ADS_CONVERSION = 'AW-16473828376/Vq4TCO-Ego0cEJjYqq89';
const DEFAULT_VALUE = 1;
const DEFAULT_CURRENCY = 'USD';

interface SendGoogleAdsOptions {
  value?: number;
  currency?: string;
}

type GtagWindow = Window & { gtag?: (...args: unknown[]) => void };

function buildPayload(label?: string, options?: SendGoogleAdsOptions) {
  const payload: { send_to: string; value: number; currency: string; event_label?: string } = {
    send_to: GOOGLE_ADS_CONVERSION,
    value: options?.value ?? DEFAULT_VALUE,
    currency: options?.currency ?? DEFAULT_CURRENCY,
  };

  if (label) {
    payload.event_label = label;
  }

  return payload;
}

export function sendGoogleAdsConversion(label?: string, options?: SendGoogleAdsOptions) {
  if (typeof window === 'undefined') return;
  const gtagWindow = window as GtagWindow;
  if (!gtagWindow.gtag) return;
  gtagWindow.gtag('event', 'conversion', buildPayload(label, options));
}
